import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

// Connects to data-controller="collapse"
export default class extends Controller {
  static targets = ["toggleButton"]

  toggleAll() {
    event.preventDefault();

    const selector = event.currentTarget.dataset.collapseTargetSelector; // Read selector from clicked button
    const collapses = document.querySelectorAll(selector || '.collapse-all-days');
    const isExpanded = event.currentTarget.getAttribute("aria-expanded") === "true";

    collapses.forEach(collapse => {
      const bsCollapse = new Collapse(collapse, { toggle: false });
      if (isExpanded) {
        bsCollapse.hide();
      } else {
        bsCollapse.show();
      }
    });

    this.toggleButtonTargets.forEach(button => {
      if (button.dataset.collapseTargetSelector === selector) {
        button.setAttribute("aria-expanded", (!isExpanded).toString());
      }
    });
  }
}
